import MojitoPresentation from 'mojito/presentation';
import { resolveMarketLayout, resolveSelectionsHeaders } from 'modules/market/helper/market-helper';

const { FlexPane, Text } = MojitoPresentation.Components;

const SelectionHeaders = props => {
    const { mojitoTools, eventItem, market, shouldShowDrawHeader, shouldShowHandicap } = props;
    const { stringResolver, config } = mojitoTools;
    const handicap =
        market?.handicap && shouldShowHandicap
            ? market?.handicap && shouldShowHandicap && (parseFloat(market.handicap) / 4).toFixed(1)
            : undefined;
    const layoutDescriptor = resolveMarketLayout(
        market,
        config.layoutDescriptors,
        eventItem.sportId
    );
    const headers = resolveSelectionsHeaders(
        layoutDescriptor,
        eventItem,
        stringResolver,
        shouldShowDrawHeader,
        handicap
    ).filter(Boolean);

    return (
        headers.length > 0 && (
            <FlexPane config={config.container}>
                {headers.map((header, index) => {
                    const key = `${header}-${index}`;
                    return (
                        <Text key={key} class="ta-SelectionsHeader" config={config.label}>
                            {header}
                        </Text>
                    );
                })}
            </FlexPane>
        )
    );
};

export default SelectionHeaders;
